/*
 * action types
 */

const tag = '@@header/'

export const UPDATE_NAV_HEADER_OPTIONS = `${tag}UPDATE_NAV_HEADER_OPTIONS`
export const SET_DISPLAY_NAV_HEADER = `${tag}SET_DISPLAY_NAV_HEADER`

/*
 * action creators
 */

export const updateNavHeaderOptions = (payload) => ({
  payload,
  type: UPDATE_NAV_HEADER_OPTIONS,
})

export const setDisplayNavHeader = (payload) => ({
  payload,
  type: SET_DISPLAY_NAV_HEADER,
})
